import { render, staticRenderFns } from "./whitePaper.vue?vue&type=template&id=f81ccebe"
import script from "./whitePaper.vue?vue&type=script&lang=js"
export * from "./whitePaper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports